module.exports = __webpack_public_path__ + "static/media/Icon feather-user-check.ea4a7bd0.svg";